module.exports = __webpack_public_path__ + "static/media/avatar.39286278.svg";